import { useOrgs } from '@hooks/useOrgs';
import { BaseReportPage } from './bases/BaseReportPage';
import { TodaysCutReport } from '@components/reports/today/TodayCutReport';

export const TodaysCuts = () => {
    useOrgs();

    return (
        <BaseReportPage title={"Today's Cuts"}>
            <TodaysCutReport />
        </BaseReportPage>
    );
};
